
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class App extends Vue {
  get layout() {
    return this.$route.meta!.layout;
  }
}
